import c from '../common';

export default {

  //Column
  "Time": "Time",

  "status": c.status.en,
  "waitForApprove": "Wait for approval",
  "approved": "Approved",
  "rejected": "Rejected",

  "currency": "Currency",

  "quantity": "Qty",
  "amount": "Total Amount(CAD)",

  "download": c.download.en.uppercase,

  "voucherName": c.voucher.en.uppercase + " Name",
  "issueId": "Issue ID",
};